export enum EntitiesSubmitErrorCode {
  DUPLICATE_ENTITIES_EXISTS = 'DUPLICATE_ENTITIES_EXISTS',
  ENTITIES_WITH_ERRORS_EXIST = 'ENTITIES_WITH_ERRORS_EXIST',
}

export interface EntityValidationErrorResponse {
  errorCode?: EntitiesSubmitErrorCode;
}
